import { ToggleGroupSingleProps } from '@radix-ui/react-toggle-group'
import { ToggleGroup, ToggleGroupItem } from './ToggleGroup'
import { testIdFactory } from '@/utils/test-id-factory.ts'

interface Option {
	value: string
	label: string
	dataTestId?: string
}

interface Props extends Omit<ToggleGroupSingleProps, 'type'> {
	options: Option[]
}

export function SegmentedButtons(props: Props) {
	return (
		<ToggleGroup type="single" size="full" {...props}>
			{props.options.map(x => (
				<ToggleGroupItem
					key={x.label}
					value={x.value}
					data-testid={x.dataTestId}
					className="border border-neutral-100 text-2xl uppercase"
				>
					{x.label}
				</ToggleGroupItem>
			))}
		</ToggleGroup>
	)
}
